import * as Yup from 'yup';

export const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email().required('Email is required'),
});

export type ForgotPasswordDataType = Yup.InferType<
  typeof ForgotPasswordSchema
>;

type InitialValues = {
  email: string;

};

export const forgotPasswordInitialValues: InitialValues = {
  email: '',
};

export interface IForgotPassword {
  email: string;
}
